<template>
  <div class="contract-wrapper">
    <base-spinner
      :is-loading="isLoading"
    />
    <div class="contract-heading" v-if="!isLoading">
      <div class="back-btn-container" @click="$router.push({name: 'profile'})">
        <img src="../../../public/custom/images/back-arrow.svg" alt="Back arrow" class="back-img">
        <span class="back-btn-text">{{ $t('message.passwordRecovery.backBtn') }}</span>
      </div>
    </div>

    <div class="contract-container">
      <div class="contract-title">
        СОГЛАСИЕ
      </div>
      <div class="contract-date">
        на предоставление кредитного отчета
      </div>

      <div class="borrower-container">
        <div class="container-block">
          <div class="container-item-large">Сведения о субъекте кредитной истории</div>
          <div class="container-item-small">Действующие</div>
          <div class="container-item-small">Прежние</div>
        </div>
        <div class="container-block">
          <div class="container-item-large start-align">Фамилия</div>
          <div class="container-item-small">{{ userLastName }}</div>
          <div class="container-item-small"></div>
        </div>
        <div class="container-block">
          <div class="container-item-large start-align">Собственное имя</div>
          <div class="container-item-small">{{ userFirstName }}</div>
          <div class="container-item-small"></div>
        </div>
        <div class="container-block">
          <div class="container-item-large start-align">Отчество (если таковое имеется)</div>
          <div class="container-item-small">{{ userMiddleName }}</div>
          <div class="container-item-small"></div>
        </div>
        <div class="container-block">
          <div class="container-item-large start-align">Гражданство</div>
          <div class="container-item-small">{{ userCitizenship }}</div>
          <div class="container-item-small"></div>
        </div>
        <div class="container-block">
          <div class="container-item-large start-align">Пол</div>
          <div class="container-item-small">{{ userSex }}</div>
          <div class="container-item-small">Х</div>
        </div>
        <div class="container-block">
          <div class="container-item-large start-align">Идентификационный номер (для гражданина Республики Беларусь, иностранного гражданина или лица без гражданства, имеющих вид на жительство в Республике Беларусь)</div>
          <div class="container-item-small">{{ userIdNumber }}</div>
          <div class="container-item-small">Х</div>
        </div>
        <div class="container-block">
          <div class="container-item-large start-align">Число, месяц, год рождения</div>
          <div class="container-item-small">{{ userBirthDate }}</div>
          <div class="container-item-small"></div>
        </div>
        <div class="container-block">
          <div class="container-item-large start-align">Сведения о документе, удостоверяющем личность (для иностранного гражданина или лица без гражданства, не имеющих вида на жительство в Республике Беларусь):</div>
          <div class="container-item-small">Х</div>
          <div class="container-item-small">Х</div>
        </div>
        <div class="container-block">
          <div class="container-item-large start-align">наименование</div>
          <div class="container-item-small"></div>
          <div class="container-item-small"></div>
        </div>
        <div class="container-block">
          <div class="container-item-large start-align">дата выдачи</div>
          <div class="container-item-small"></div>
          <div class="container-item-small"></div>
        </div>
        <div class="container-block">
          <div class="container-item-large start-align">серия и номер</div>
          <div class="container-item-small"></div>
          <div class="container-item-small"></div>
        </div>
        <div class="desc">
          <p class="indented-paragraph">
            Выражаю согласие Обществу с ограниченной ответственностью «Инновационные Финансовые Стратегии» (далее - Пользователь кредитной истории) на предоставление ему Национальным банком Республики Беларусь моего кредитного отчета для скоринговой оценки.
          </p>
          <p class="indented-paragraph">
            Настоящее  согласие  действует  в  течение  трех  месяцев  с  даты его оформления,  а  в  случае  заключения  в  течение  трех  месяцев с даты его оформления   кредитной   сделки   между  Пользователем  кредитной   истории и   субъектом  кредитной   истории - в   течение   всего   срока   действия указанной    кредитной    сделки   до   ее   прекращения   в  установленном законодательством  порядке.  Согласие на предоставление кредитного отчета, оформленное в течение срока действия кредитной сделки, заключенной между Пользователем кредитной истории и субъектом кредитной истории, действует в течение всего срока действия указанной кредитной сделки до ее прекращения в установленном законодательством порядке. Согласие субъекта кредитной истории, являющегося должником по открытому факторингу или факторинговой операции, оформленное в течение срока действия денежного требования, права по которому уступлены Пользователю кредитной истории по договору факторинга или факторинговой операции, действует в течение всего срока действия указанного требования до его прекращения в установленном законодательством порядке.
          </p>
        </div>
        <div class="block-title">ПОДПИСЬ ЗАЕМЩИКА</div>

        <div class="sign-offer-block">
          <div class="sign-offer-item">
            <div
              class="check-box-btn"
              :class="{ 'check-box-checked': isAgreeWithServiceAgreement }"
              @click.stop="checkboxHandler()"
            >
              <img
                v-if="isAgreeWithServiceAgreement"
                class="check-box-image"
                src="../../../public/custom/images/check.svg"
                alt="Checket image"
              />
            </div>
            <div
              class="check-box-label"
              @click.stop="checkboxHandler()"
            >
            Текст Согласия прочитан мной полностью, с условиями Согласия ознакомлен(а) и согласен(а)
            </div>
          </div>
          <div class="otp-container">
            <div class="otp-block">
              <base-text-input
                :mask-pattern="'######'"
                :name="'otp'"
                :validate-rules="'otp'"
                :placeholder="$t('message.contract.otp.placeholder')"
                v-model="otp"
                :disabled="isSignBtnLoading"
              />
            </div>
            <div class="send-otp-block" @click="getOtpCode()">Получить код</div>
          </div>
        </div>
        <div class="borrower-sign-block">
          <div>Заемщик:</div>
          <div class="full-name">{{ userLastName }} {{ userFirstName }} {{ userMiddleName }}</div>
        </div>
        <div class="btns-block">
          <div class="btn-container">
            <base-button
              :text="$t('message.contract.btn')"
              :disabled="isSignBtnDisabled"
              @click="signAgreement()"
              :is-loading="isSignBtnLoading"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTextInput from '../../components/base/BaseTextInput.vue';
import BaseButton from '../../components/base/BaseButton.vue';
import BaseSpinner from '../../components/base/BaseSpinner.vue';

export default {
  name: 'ScoringAgreement',
  inject: ['$httpService'],
  components: {
    BaseTextInput,
    BaseButton,
    BaseSpinner
  },
  data() {
    return {
      isAgreeWithServiceAgreement: false,
      message_id: '',
      otp: '',
      isSignBtnLoading: false,
      agreementId: '',
      isLoading: true
    }
  },
  async created() {
    try {
      const response = await this.$httpService.agreement.createAgreement();
      this.agreementId = response.data.document_id;
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      this.$router.push({name: 'profile'})
    }
  },
  methods: {
    checkboxHandler() {
      if(!this.isSignBtnLoading) {
        this.isAgreeWithServiceAgreement = !this.isAgreeWithServiceAgreement;
      }
    },
    async getOtpCode() {
      if (!this.isSignBtnLoading) {
        try {
          const response = await this.$httpService.loan.getOtpCode(this.profile?.contact?.phoneSMSVerification);

          this.message_id = response.data.message_id;
          this.$toast({text: this.$t('message.signIn.otpToastMsg')});
        } catch (error) {
          this.$router.push({name: 'profile'});
        }
      }
    },
    async signAgreement() {
      this.isSignBtnLoading = true;
      try {
        const agreement_id = '' + this.agreementId;
        const otp = +this.otp;
        const response = await this.$httpService.agreement.signAgreement(agreement_id, otp);
        this.$router.push({name: 'profile', params: {data: response.data}});
        this.isSignBtnLoading = false;
      } catch (error) {
        this.isSignBtnLoading = false;
      }
    }
  },
  computed: {
    ...mapGetters(['profile']),
    userLastName() {
      return this.profile?.name_ru?.family_name_ru;
    },
    userFirstName() {
      return this.profile?.name_ru?.given_name_ru;
    },
    userMiddleName() {
      return this.profile?.name_ru?.middle_name_ru;
    },
    userCitizenship() {
      return this.profile?.citizenship;
    },
    userSex() {
      return this.profile?.sex === 'male' ? 'Мужской' : 'Женский';
    },
    userIdNumber() {
      return this.profile?.national_id_number;
    },
    userBirthDate() {
      const date = this.profile?.birthdate;
      const year = date.slice(0, 4);
      const month = date.slice(4, 6);
      const day = date.slice(6, 8);
      return `${day}.${month}.${year}`;
    },
    isHasFieldsErrors() {
      return this.errors.items.length > 0;
    },
    isHasEmptyFields() {
      return !this.otp;
    },
    isSignBtnDisabled() {
      return this.isHasFieldsErrors || this.isHasEmptyFields || !this.isAgreeWithServiceAgreement || this.isSignBtnLoading;
    }
  }
}
</script>

<style lang="scss" scoped>
.contract-wrapper {
    @include base-page-wrapper;
  }

  .contract-heading,
  .contract-container {
    @include base-page-container;
  }

  .contract-container {
    width: 1550px;
    max-width: 90%;
    flex-direction: column;
  }

  .back-btn-container {
    margin-top: 30px;
    margin-bottom: 28px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.back-img {
    margin-right: 4px;
    height: 18px;
    width: 18px;
}

.back-btn-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 135%;
    color: var(--password-recovery-back-btn-color);
}

.contract-title,
.contract-date,
.block-title,
.offer-title {
  width: 100%;
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: calc(20px + 20 * (100vw / 1920));
  line-height: 125%;
  color: #121212;
  text-align: center;
}

.contract-date {
  margin-bottom: 50px;
  font-size: calc(16px + 20 * (100vw / 1920));
}

.borrower-container {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  margin-bottom: 100px;
}

.container-block {
  width: 100%;
  display: flex;
}

.container-item-large {
  min-width: 300px;
  min-height: 69.5px;
  width: calc(40%);
  padding: 15px;
  box-sizing: border-box;
  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(10px + 15 * (100vw / 1920));
  line-height: 125%;
  font-weight: 500;
  text-align: center;
}

.container-item-small {
  min-width: 150px;
  min-height: 69.5px;
  width: calc(30%);
  padding: 15px;
  box-sizing: border-box;
  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(10px + 15 * (100vw / 1920));
  line-height: 125%;
  font-weight: 500;
  text-align: center;
}

.start-align {
  text-align: start;
}

.indented-paragraph {
  padding: 0;
  margin: 0;
  margin-bottom: 10px;
  text-indent: calc(20px + 40 * (100vw / 1920));
  font-size: calc(20px + 10 * (100vw / 1920));
  line-height: 125%;

  a {
    color: blue;
  }
}

.desc {
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.sign-offer-block {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.sign-offer-item {
  margin-bottom: 50px;
  display: flex;
  align-items: flex-start;
}

.check-box-btn {
  @include base-check-box;
  width: 34px;
  height: 34px;
}

.check-box-label {
  @include base-check-box-label;

  font-size: calc(15px + 10 * (100vw / 1920));
  line-height: 125%;
  font-weight: 500;
}

.otp-container {
  display: flex;
  align-items: center;
}

.otp-block {
  width: 197px;
  margin-right: 20px;
}

.send-otp-block {
  margin-bottom: 30px;
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  letter-spacing: 0.01em;
  text-decoration-line: underline;
  color: #41BF7B;
  cursor: pointer;
}

.btns-block {
  margin-top: 100px;
  margin-bottom: 200px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.btn-container {
  width: 300px;
  height: 65px;
}

.borrower-sign-block {
  margin: 50px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: calc(10px + 15 * (100vw / 1920));
  line-height: 125%;
}

.full-name {
  text-decoration: underline;
}
</style>